@if (loaded) {
  <div class="terms-and-conditions">
    <div class="terms-and-conditions__header">
      {{ 'terms_and_conditions.header' | i18nextEager }}
    </div>
    <div class="terms-and-conditions__body">
      {{ 'terms_and_conditions.body' | i18nextEager }}
    </div>
    <div class="terms-and-conditions__checkbox">
      <bdeo-checkbox #checkbox class="terms-and-conditions__checkbox-input" size="medium" (change)="toggleCheckbox()"></bdeo-checkbox>
      <span class="terms-and-conditions__label-container">
        <span class="terms-and-conditions__checkbox-text">
          {{ 'brokers:terms_and_conditions.checkbox_suffix' | i18nextEager }}
        </span>

        <a class="terms-and-conditions__checkbox-link" (click)="showUseConditions()">
          {{ 'brokers:terms_and_conditions.checkbox_link' | i18nextEager }}
        </a>
      </span>
    </div>
    @if (termsNotLoadedError) {
      <div class="terms-and-conditions__error">
        {{ 'terms_and_conditions.error' | i18nextEager }}
      </div>
    }
    <app-footer selectorForPadding=".terms-and-conditions">
      <bdeo-button
        data-test-id="accept-terms-and-conditions"
        type="primary"
        [text]="'terms_and_conditions.button' | i18nextEager"
        [disabled]="!checkboxChecked"
        (click)="acceptTermsAndConditions()"
      ></bdeo-button>
    </app-footer>
  </div>
} @else {
  <div class="loading">
    <bdeo-icon color="var(--pill-blue)" size="large" name="loading-circle"></bdeo-icon>
  </div>
}
